import { AmplitudeCategories, createTrackerForCategory } from "./amplitude";

const trackEvent = createTrackerForCategory(AmplitudeCategories.Auth);

enum events {
    ChangedPassword = "ChangedPassword",
    DeletedAccount = "DeletedAccount",
    DuplicateSessionLogOut = "DuplicateSessionLogOut",
    Login = "login",    // lowercase string required for backward compatibility with Amplitude.
    Logout = "logout",  // lowercase string required for backward compatibility with Amplitude.
    Signup = "signup",
    VerifyEmail = "VerifyEmail"
}

async function _getAuthController() {
    // @ts-ignore
    return await import("js/controllers/AuthController").then(module => module.default);
}

export function Login({ email, uid } : { email: string, uid: string }) {
    const eventProperties = {
        email: email,
        userId: uid,
        workspace_id: "all"
    };
    trackEvent(events.Login, eventProperties, { audit: true });
}

export function Signup({ email, uid }: { email: string, uid: string }) {
    const eventProperties = {
        email: email,
        userId: uid,
        workspace_id: "all"
    };

    trackEvent(events.Signup, eventProperties,
        {
            audit: true,
            gtag: "conversion"
        });
}

export async function VerifyEmail() {
    const authController = await _getAuthController();
    const user = authController.currentUser;
    const eventProperties = {
        email: user?.email,
        userId: user?.uid,
        workspace_id: "all"
    };

    trackEvent(events.VerifyEmail, eventProperties, { audit: true });
}
